import { get, update } from "lodash";
import { baseApi } from "..";
import { checkIsAdmin } from "../../../helpers/helpers";

// Define a service using a base URL and expected endpoints
export const prodOrderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    getTrimType: builder.query({
      query: () => `trim-type`,
      transformResponse: (response) => response.data,
    }),
    getLabelTypes: builder.query({
      query: () => `label-types`,
      transformResponse: (response) => response.data,
    }),

    getLabelsTemplates: builder.query({
      query: () => `labels`,
      transformResponse: (response) => response.data,
    }),

    submitLabelDetails: builder.mutation({
      query: ({ production_order_id, labels }) => ({
        url: `production-orders/${production_order_id}/label-details`,
        method: "POST",
        body: {
          labels,
        },
      }),
      transformResponse: (response) => response.data,
    }),

  }),
  overrideExisting: false,
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetLabelTypesQuery,
  useGetLabelsTemplatesQuery,
  useSubmitLabelDetailsMutation,
} = prodOrderApi;